module.exports = __webpack_public_path__ + "img/cartaz.6d89a0f4.jpg";